import React from 'react';
import { Alert, AlertTitle, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';

// 文言管理（将来的な一元管理のための構造）
const messages = {
  productRegistrationRequired: {
    title: "製品が登録されていません",
    description: "製品情報を追加するには、製品を登録してください。",
    actionLabel: "製品を登録する"
  }
};

/**
 * 製品情報がない場合のメッセージコンポーネント
 */
const EmptyProductState = () => {
  const navigate = useNavigate();

  const handleProductRegistration = () => {
    navigate('/product-registration');
  };

  return (
    <Alert 
      severity="info" 
      sx={{ 
        my: 3,
        '& .MuiAlert-message': {
          width: '100%'
        }
      }}
    >
      <Box sx={{ width: '100%' }}>
        <AlertTitle sx={{ fontWeight: 500, mb: 1 }}>
          {messages.productRegistrationRequired.title}
        </AlertTitle>
        <Typography variant="inherit" sx={{ mb: 2 }}>
          {messages.productRegistrationRequired.description}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleProductRegistration}
          aria-label="製品登録ページに移動"
          sx={{
            fontSize: '0.8125rem',
            fontWeight: 600
          }}
        >
          {messages.productRegistrationRequired.actionLabel}
        </Button>
      </Box>
    </Alert>
  );
};

export default EmptyProductState;